export const CSS = {
  scrim: "scrim",
  content: "content",
};

export const BREAKPOINTS = {
  s: 72, // Less than 72px.
  // medium is assumed default.
  l: 480, // Greater than or equal to 480px.
};
